import instance from "../axios_base";

export let apiGetRoute = () => instance.get("/Route/GetRoute");

//���ҵn�J���A(Token)�H�άO�_��i�J�ӭ����B�è��o�ϥΪ̦W��
export let apiRouteVerify = (route, params) =>
  instance.post("/Route/Verify", { uid: "0", route, params });
